import { AuthenticatedTemplate, useMsal } from "@azure/msal-react";
import React, { useEffect, useState } from "react";
import { Navigate } from "react-router";
import { LandingPage } from "./LandingPage";

const MainContent = () => {
  const [landingPage, setLandingPage] = useState<undefined | string>(undefined);
  const { instance } = useMsal();

  useEffect(() => {
    instance.handleRedirectPromise().then((response) => {
      if (response?.state) {
        const trimmedState = response.state.trim();
        const urlExp = new RegExp("^\\/([a-zA-Z0-9]+\\/)*[a-zA-Z0-9]+$");
        if (urlExp.test(trimmedState)) {
          setLandingPage(trimmedState);
        }
      } else {
        setLandingPage("/home");
      }
    });

    return;
  }, []);

  return (
    landingPage && (
      <>
        <div>
          <AuthenticatedTemplate>
            <Navigate to={landingPage} />
          </AuthenticatedTemplate>
        </div>
      </>
    )
  );
};

export default function LandingRouter() {
  return (
    <LandingPage>
      <MainContent />
    </LandingPage>
  );
}
